enum AppTypes {
  Chatbot = 'chatbot',
  Messenger = 'messenger',
  PrivateChatBulkMessages = 'privateChatBulkMessages',
}

export default AppTypes;
